<template>
  <div>
    <h6 class="text-h6 zubie-font q-mt-lg">Account Logo</h6>
    <div class="text-body2 q-mb-md">You can upload a logo to appear on your Zubie Sense Event PDF reports.</div>
    <div>
      <ImagePicker
        class="full-width"
        :class="[{ 'has-image': Boolean(logoUrl) }]"
        :model-value="logoUrl"
        :revert="showUndo"
        :style="{ height: '56px' }"
        @clear="onChange(null)"
        @error="uploadError = $event"
        @revert="
          onChange(existingUrl);
          showUndo = false;
        "
        @update:model-value="onChange($event)"
        @upload="$emit('upload')"
        @uploaded="$emit('uploaded')"
      >
        <template #upload-message>
          <div class="row items-center no-wrap text-no-wrap line-height-1">
            <q-icon name="cloud_upload" />
            <div class="q-ml-xs">Upload a {{ logoUrl ? 'New' : 'Custom' }} Logo</div>
          </div>
        </template>
      </ImagePicker>

      <div class="logo-help text-caption text-grey-7">Recommended logo size: 3:1 ratio, e.g. 750x250</div>

      <BannerNegative v-if="uploadError" class="q-my-sm q-ml-sm">{{ uploadError }}</BannerNegative>

      <BannerInfo v-if="showUndo && !logoUrl" class="logo-banner-message q-my-xs"
        >The logo will be set to the default Zubie logo.</BannerInfo
      >

      <div v-if="logoUrl !== existingUrl" class="logo-preview q-mt-sm q-pa-md shadow-4">
        <LogoPreview :custom-logo="existingUrl" label="Before" />
        <div class="row justify-center">
          <q-icon class="q-my-xs text-grey-5" name="keyboard_double_arrow_down" size="md" />
        </div>
        <LogoPreview :custom-logo="logoUrl" label="After" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import LogoPreview from 'components/account/LogoPreview.vue';
import BannerInfo from 'components/BannerInfo.vue';
import BannerNegative from 'components/BannerNegative.vue';
import ImagePicker from 'components/ImagePicker.vue';
import { DEFAULT_LOGO_URL } from 'src/services/constants';

const emit = defineEmits(['update:logo-use', 'update:model-value', 'upload', 'uploaded']);

const store = useStore();

const account = computed(() => store.state.session.account);
const existingUrl = computed(() => (account.value.logoUrl !== DEFAULT_LOGO_URL ? account.value.logoUrl : null));

const logoUrl = ref<string | null>(existingUrl.value);
const showUndo = ref(false);
const uploadError = ref<string>();

async function onChange(value: string | null) {
  logoUrl.value = value;
  showUndo.value = true;
  emit('update:model-value', value);
}
</script>

<style scoped lang="scss">
.logo-banner-message,
.logo-preview {
  margin-right: 36px;
}

.logo-preview {
  border: 1px solid rgba(87, 66, 224, 0.2);
}
</style>
